import React, { createContext, useContext } from "react";

const EnvironmentContext = createContext();

export const EnvironmentProvider = ({ children }) => {
  const isDemoEnvironment =
    window.location.hostname === "demo.surelia.mx";
  //const isDemoEnvironment = false;

  return (
    <EnvironmentContext.Provider value={{ isDemoEnvironment }}>
      {children}
    </EnvironmentContext.Provider>
  );
};

export const useEnvironment = () => {
  const context = useContext(EnvironmentContext);
  if (!context) {
    throw new Error("useEnvironment must be used within an EnvironmentProvider");
  }
  return context;
};
